import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { hasNavigatorApi } from 'utils/browser.utils';

import Icon from 'components/@icons/Icon';

import { useNavigatorShare } from './useNavigatorShare';

interface Props {
  url: string;
  ariaTitle?: string;
  onShare?: () => void;
}

const DynamicShareButton = ({ url, onShare, ariaTitle }: Props) => {
  const { navigatorShare } = useNavigatorShare();
  const [open, setOpen] = useState(false);
  const isNative = hasNavigatorApi('share');

  const handleNavigatorShare = async () => {
    if (!isNative) setOpen(true);
    await navigatorShare({ url });
    onShare?.();
  };

  return (
    <Tooltip
      open={open}
      onClose={() => setOpen(false)}
      title={<FormattedMessage id="feedback.copied_to_clipboard" />}
    >
      <IconButton
        size="small"
        sx={(theme) => ({
          transition: theme.transitions.create('transform'),
          '&:hover': {
            transform: 'scale(1.1)',
          },
        })}
        onClick={handleNavigatorShare}
        aria-label={`Share: ${ariaTitle}`}
        disableRipple
      >
        <Icon name={isNative ? 'Share' : 'Url'} fontSize={24} />
      </IconButton>
    </Tooltip>
  );
};

export default DynamicShareButton;
